<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_031"><img alt="Image" src="images/f0017-01.jpg"/></a></p><a id="file_031">
<p class="caption">Grumman’s second fighter was smaller and speedier than the FF-1. Here, the prototype XF2F-1 is captured on film in the moment before takeoff. Many suspect that this image shows the plane’s first flight, which took place on October 18, 1933. <em>Grumman History Center</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_031.vue?e2119934